module.exports = __webpack_public_path__ + "img/minus-circle-48px.9e330b3.svg";